
$(document).ready(function() {

    var is_supported_browser = !!window.File,
        fileSizeToBytes,
        formatter = $.validator.format;

    fileSizeToBytes = (function () {

        var units = ["B", "KB", "MB", "GB", "TB"];
        return function (size, unit) {
            var index_of_unit = units.indexOf(unit),
                coverted_size;

            if (index_of_unit === -1) {
                coverted_size = false;
            } 
            else {
                while (index_of_unit > 0) {
                    size *= 1024;
                    index_of_unit -= 1;
                }
                coverted_size = size;
            }
            return coverted_size;
        };
    }());

    $.validator.addMethod(
        "maxFileSize",
        function (value, element, params) {

            var files,
                unit = params.unit || "MB",
                size = params.size || 1,
                max_file_size = fileSizeToBytes(size, unit),
                is_valid = false;

            if (!is_supported_browser || this.optional(element)) {
                is_valid = true;
            } 
            else {

                files = element.files;
                if (files.length < 1) {
                    is_valid = false;
                } 
                else {
                    is_valid = files[0].size <= max_file_size;
                }
            }

            return is_valid;
        },
        function (params, element) {
            return formatter(
                "Image cannot be larger than {0}{1}.",
                [params.size || 1, params.unit || "MB"]
            );
        }
    );

/* SUBMIT EVENT FORM ***************************/
    $("#submit-event-form").validate({
        rules: {
            event_name: {
                required: true,
            },
            event_category: {
                required: true,
            },
            event_venue_address: {
                required: true,
            },
            event_organizer_name: {
                required: true,
            },
            event_organizer_phone: {
                required: true,
                minlength: 12,
            },
            event_organizer_email: {
                required: true,
                email: true
            },
            event_website: {
                required: true,
            },
            event_image: {
                extension: "jpg|jpeg",
                maxFileSize: 1
            }
            /*
            family_state: {
                required: true
            },
            family_zip: {
                required: true,
                number: true,
                minlength: 5,
            },
            */

        },
        messages: {
            
            event_organizer_phone: {
                minlength: "Please enter a valid phone number"
            }
            /*
            family_zip: {
                number: "Please enter a valid zip code",
                minlength: "Must be at least 5 numbers"
            }
            */
        }
    });

});